export const usStates = [
  {
    value: 'Alabama',
    code: 'AL'
  },
  {
    value: 'Alaska',
    code: 'AK'
  },
  {
    value: 'American Samoa',
    code: 'AS'
  },
  {
    value: 'Arizona',
    code: 'AZ'
  },
  {
    value: 'Arkansas',
    code: 'AR'
  },
  {
    value: 'California',
    code: 'CA'
  },
  {
    value: 'Colorado',
    code: 'CO'
  },
  {
    value: 'Connecticut',
    code: 'CT'
  },
  {
    value: 'Delaware',
    code: 'DE'
  },
  {
    value: 'District Of Columbia',
    code: 'DC'
  },
  {
    value: 'Federated States Of Micronesia',
    code: 'FM'
  },
  {
    value: 'Florida',
    code: 'FL'
  },
  {
    value: 'Georgia',
    code: 'GA'
  },
  {
    value: 'Guam',
    code: 'GU'
  },
  {
    value: 'Hawaii',
    code: 'HI'
  },
  {
    value: 'Idaho',
    code: 'ID'
  },
  {
    value: 'Illinois',
    code: 'IL'
  },
  {
    value: 'Indiana',
    code: 'IN'
  },
  {
    value: 'Iowa',
    code: 'IA'
  },
  {
    value: 'Kansas',
    code: 'KS'
  },
  {
    value: 'Kentucky',
    code: 'KY'
  },
  {
    value: 'Louisiana',
    code: 'LA'
  },
  {
    value: 'Maine',
    code: 'ME'
  },
  {
    value: 'Marshall Islands',
    code: 'MH'
  },
  {
    value: 'Maryland',
    code: 'MD'
  },
  {
    value: 'Massachusetts',
    code: 'MA'
  },
  {
    value: 'Michigan',
    code: 'MI'
  },
  {
    value: 'Minnesota',
    code: 'MN'
  },
  {
    value: 'Mississippi',
    code: 'MS'
  },
  {
    value: 'Missouri',
    code: 'MO'
  },
  {
    value: 'Montana',
    code: 'MT'
  },
  {
    value: 'Nebraska',
    code: 'NE'
  },
  {
    value: 'Nevada',
    code: 'NV'
  },
  {
    value: 'New Hampshire',
    code: 'NH'
  },
  {
    value: 'New Jersey',
    code: 'NJ'
  },
  {
    value: 'New Mexico',
    code: 'NM'
  },
  {
    value: 'New York',
    code: 'NY'
  },
  {
    value: 'North Carolina',
    code: 'NC'
  },
  {
    value: 'North Dakota',
    code: 'ND'
  },
  {
    value: 'Northern Mariana Islands',
    code: 'MP'
  },
  {
    value: 'Ohio',
    code: 'OH'
  },
  {
    value: 'Oklahoma',
    code: 'OK'
  },
  {
    value: 'Oregon',
    code: 'OR'
  },
  {
    value: 'Palau',
    code: 'PW'
  },
  {
    value: 'Pennsylvania',
    code: 'PA'
  },
  {
    value: 'Puerto Rico',
    code: 'PR'
  },
  {
    value: 'Rhode Island',
    code: 'RI'
  },
  {
    value: 'South Carolina',
    code: 'SC'
  },
  {
    value: 'South Dakota',
    code: 'SD'
  },
  {
    value: 'Tennessee',
    code: 'TN'
  },
  {
    value: 'Texas',
    code: 'TX'
  },
  {
    value: 'Utah',
    code: 'UT'
  },
  {
    value: 'Vermont',
    code: 'VT'
  },
  {
    value: 'Virgin Islands',
    code: 'VI'
  },
  {
    value: 'Virginia',
    code: 'VA'
  },
  {
    value: 'Washington',
    code: 'WA'
  },
  {
    value: 'West Virginia',
    code: 'WV'
  },
  {
    value: 'Wisconsin',
    code: 'WI'
  },
  {
    value: 'Wyoming',
    code: 'WY'
  }
];

export default usStates;
